import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

export const useIframeLoadingState = ({
  iframeRef,
  onLoadCallback = () => undefined
} = {}) => {
  const theme = useTheme();

  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  // Adapted from https://www.michaelfasani.com/2021/detect-if-iframe-is-fully-loaded-react-custom-hook/
  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    iframeRef?.current?.addEventListener('load', () => {
      try {
        setIsIframeLoaded(true);
        onLoadCallback(iframeRef?.current);

        /**
         * https://github.com/eduphoria/SchoolObjects.NET/blob/main/SchoolObjectsAnalysis/aware/Analysis/ADAnalysis/DataViewer.aspx
         * and similar pages do strange things to get the table to scroll. I've replicated what I believe
         * needs to be done to get to work when loaded via an iframe
         */

        const offset =
          window.innerHeight -
          iframeRef?.current?.clientHeight +
          theme.mixins.denseToolbar.minHeight;
        /**
         * Set height of viewDiv and dataDiv so that page will scroll properly
         */
        const viewDiv =
          iframeRef?.current?.contentWindow.document.getElementById('viewDiv');

        if (viewDiv) {
          viewDiv.style.height = iframeRef?.current?.clientHeight - offset;
        }

        const dataDiv =
          iframeRef?.current?.contentWindow.document.getElementById('dataDiv');

        if (dataDiv) {
          dataDiv.style.width = iframeRef?.current?.clientWidth;
        }
      } catch (e) {
        console.log(e);
      }
    });

    return () => {
      // eslint-disable-next-line no-unused-expressions
      iframeRef?.current?.removeEventListener('load', () => setIsIframeLoaded(true));
    };
  }, [iframeRef]);

  return {
    isIframeLoaded,
    iframeRef
  };
};
